import React from 'react';

export function highlightMatch(text, search, Wrapper = (t) => <>{t}</>) {
  if (!search) return text;

  const lowerSearch = search.toLowerCase();
  const regex = new RegExp(`(${lowerSearch})`, 'gi');

  const parts = String(text).split(regex);

  return parts.map((part, idx) =>
    part.toLowerCase() === lowerSearch ? (
      <React.Fragment key={idx}>{Wrapper(part)}</React.Fragment>
    ) : (
      <React.Fragment key={idx}>{part}</React.Fragment>
    )
  );
}
